import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ebw-map-full-screen',
  templateUrl: './full-screen.component.html',
  styleUrls: ['./full-screen.component.scss']
})
export class FullScreenComponent implements OnInit {

  constructor(
  ) { }

  ngOnInit(): void {
  }

  goFullScreen(){
    const elem = document.documentElement;
    const methodToBeInvoked =
      elem.requestFullscreen ||
      elem["webkitRequestFullScreen"] ||
      elem["mozRequestFullScreen"] ||
      elem["msRequestFullscreen"];
    if (methodToBeInvoked) {
      methodToBeInvoked.call(elem);
    }
  }

}
